import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';

import { LOCKED_BY_NOT_VISIBLE, visibilityOf } from './advertModel';

const ITEMS = [
  { field: 'featured', label: 'Featured' },
  { field: 'mostPopular', label: 'Most Popular' },
  { field: 'publicListed', label: 'Public' },
  { field: 'preinstalled', label: 'Preinstalled' },
  { field: 'notVisible', label: 'Not Visible' }
];

/**
 * The right-rail visibility checklist (AC2). Two rules live here:
 *
 * - Not Visible locks Featured / Most Popular / Public — greyed AND forced off, so they cannot be
 *   submitted checked (the caller applies applyVisibilityLock on change, which is what clears them).
 *   Preinstalled stays active: a hidden advert can still be preinstalled.
 * - Public unchecked is not "invisible", it is Unlisted (CQ-3) — off the store listing but still
 *   installable by anyone holding the advert uuid. That distinction is the whole reason for the
 *   helper text; without it "not public" reads as "nobody can install it", which is false.
 */
const VisibilityChecklist = ({ form, disabled, onChange }) => {
  const locked = field => form.notVisible && LOCKED_BY_NOT_VISIBLE.includes(field);
  const state = visibilityOf(form);

  return (
    <div>
      {ITEMS.map(item => (
        <FormGroup check key={item.field} className="mb-1">
          <Input
            id={`visibility-${item.field}`}
            type="checkbox"
            checked={!!form[item.field]}
            disabled={disabled || locked(item.field)}
            onChange={e => onChange(item.field, e.target.checked)}
          />
          <Label check for={`visibility-${item.field}`} className={locked(item.field) ? 'text-muted' : ''}>
            {item.label}
          </Label>
        </FormGroup>
      ))}

      {form.notVisible ? (
        <div className="text-muted mt-2" style={{ fontSize: 12 }}>
          <strong>Not Visible</strong> hides the advert completely — delisted, and not installable even
          with a direct link. Featured, Most Popular and Public are locked while it is on.
        </div>
      ) : null}

      {state === 'UNLISTED' ? (
        <div className="text-muted mt-2" style={{ fontSize: 12 }}>
          <strong>Unlisted</strong>: hidden from the App Store listing, but still installable by anyone
          with the shared advert link.
        </div>
      ) : null}
    </div>
  );
};

export default VisibilityChecklist;
